import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
// @material-ui/core components
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
//import custom components
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import LocationHeader from "components/Headers/LocationHeader";
import useQueryParams from "hooks/useQueryParams";
import { titles } from "resources/resources";
import { PAGINATION } from "utils/const";
import FilterSection from "./Sections/InformationDissemination_FilterSection";
import ResultSection from "./Sections/InformationDissemination_ResultSection";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function InformationDissemination(props) {
  const classes = useStylesGeneric();
  const intl = useIntl();
  const { getQueryParam, setQueryParams, getQueryParams } = useQueryParams();

  const form = useForm({
    mode: "onChange",
    defaultValues: {
      searchText: getQueryParam("searchText") || "",
      // select values are restored as primitive keyValue; FilterSection converts to option objects when datasets are ready
      informationDisseminationTypeKeyValue: getQueryParam("informationDisseminationTypeKeyValue") ?? null,
      searchPublishPeriodKeyValue: getQueryParam("searchPublishPeriodKeyValue") ?? null,
      pageIndex: getQueryParam("pageIndex") || PAGINATION.FIRST_PAGE,
      pageSize: PAGINATION.PAGE_SIZE_DISSEMINATION,
    },
  });

  const { watch } = form;
  const pageIndex = watch("pageIndex") ?? PAGINATION.FIRST_PAGE;

  // Sync pagination to URL (pageIndex only when > 1)
  useEffect(() => {
    const currentParams = getQueryParams();
    if (Number(pageIndex) > 1) {
      currentParams.pageIndex = Number(pageIndex);
    } else {
      delete currentParams.pageIndex;
    }
    setQueryParams(currentParams, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);

  return (
    <Grid container classes={{ root: classes.containerRoot }}>
      <LocationHeader
        section="Publicações"
      />
      <FormProvider {...form}>
        <Grid item xs={12} md={12}>
          <FilterSection
            informationDisseminationType={props.match.params.infoType}
            title={intl.formatMessage(titles.Title_Posts)}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <ResultSection />
        </Grid>
      </FormProvider>
    </Grid>
  );
}

const mapStateToProps = (state) => ({ ...state });

export default connect(mapStateToProps)(InformationDissemination);
